/**
 * Mock data that mirrors every chart/card in the old FleetDashboard.
 *
 * Once real API response keys are provided, each dataset will be derived
 * from the stats API response instead of these hardcoded values.
 */

// ── Operational Health ──
export const MOCK_CHARGER_STATUS_DONUT = [
  { status: "charging", count: 38 },
  { status: "online", count: 120 },
  { status: "preparing", count: 15 },
  { status: "offline", count: 22 },
  { status: "faulted", count: 5 },
];

export const MOCK_CONNECTIVITY = [
  { name: "Online", value: 178 },
  { name: "Offline", value: 22 },
];

export const MOCK_FLEET_HEALTH = [
  { name: "Healthy", value: 195 },
  { name: "Faulted", value: 5 },
];

export const MOCK_COMMISSIONING = [
  { name: "Commissioned", value: 160 },
  { name: "Pending", value: 25 },
  { name: "Not Commissioned", value: 15 },
];

export const MOCK_OFFLINE_DURATION = [
  { name: "< 1 hr", value: 8 },
  { name: "1–6 hr", value: 6 },
  { name: "6–24 hr", value: 5 },
  { name: "> 24 hr", value: 3 },
];

// ── Firmware & Maintenance ──
export const MOCK_FW_VERSIONS = [
  { name: "3.2.1", value: 80 },
  { name: "3.1.0", value: 55 },
  { name: "2.9.4", value: 40 },
  { name: "2.8.0", value: 25 },
];

export const MOCK_FW_FRESHNESS = [
  { name: "< 7 days", value: 60 },
  { name: "7–30 days", value: 55 },
  { name: "30–90 days", value: 50 },
  { name: "> 90 days", value: 25 },
  { name: "Never", value: 10 },
];

export const MOCK_MODEL = [
  { name: "IQ EVSE Gen 2", value: 110 },
  { name: "IQ EVSE Gen 1", value: 60 },
  { name: "IQ EVSE Pro", value: 30 },
];

export const MOCK_SKU = [
  { name: "EVSE-G2-NA-32", value: 80 },
  { name: "EVSE-G2-EU-16", value: 50 },
  { name: "EVSE-G1-NA-32", value: 40 },
  { name: "EVSE-PRO-48", value: 30 },
];

// ── Fleet Configuration ──
export const MOCK_PHASE = [
  { name: "1-Phase", value: 120 },
  { name: "3-Phase", value: 80 },
];

export const MOCK_DLB = [
  { name: "DLB Enabled", value: 140 },
  { name: "DLB Disabled", value: 60 },
];

export const MOCK_PARTNER = [
  { name: "Partner Integrated", value: 90 },
  { name: "Standalone", value: 110 },
];

export const MOCK_OFFGRID = [
  { name: "Off-Grid", value: 25 },
  { name: "On-Grid", value: 175 },
];

// ── Deployment & Config ──
export const MOCK_MODE = [
  { name: "Standard", value: 100 },
  { name: "Solar", value: 60 },
  { name: "Off-Peak", value: 40 },
];

export const MOCK_OFF_PEAK = [
  { name: "Eligible", value: 130 },
  { name: "Not Eligible", value: 70 },
];

export const MOCK_VENDOR = [
  { name: "Enphase", value: 150 },
  { name: "Partner A", value: 30 },
  { name: "Partner B", value: 20 },
];

export const MOCK_MAX_CURRENT = [
  { name: "32A", value: 120 },
  { name: "16A", value: 50 },
  { name: "48A", value: 30 },
];

// ── KPI panel ──
export const MOCK_ENERGY_DATA = Array.from({ length: 7 }, (_, i) => ({
  date: `Jun ${17 + i}`,
  energy: Math.round(200 + Math.random() * 300),
  sessions: Math.round(40 + Math.random() * 60),
}));

export const MOCK_TOP_SITES = [
  { name: "Site Alpha", chargers: 12, sessions: 320, energy: 4800, utilizationTime: "128h", utilization: 82 },
  { name: "Site Beta", chargers: 8, sessions: 210, energy: 3100, utilizationTime: "96h", utilization: 74 },
  { name: "Site Gamma", chargers: 6, sessions: 150, energy: 2200, utilizationTime: "72h", utilization: 68 },
  { name: "Site Delta", chargers: 10, sessions: 280, energy: 4200, utilizationTime: "110h", utilization: 65 },
  { name: "Site Epsilon", chargers: 5, sessions: 95, energy: 1400, utilizationTime: "48h", utilization: 55 },
  { name: "Site Zeta", chargers: 4, sessions: 60, energy: 900, utilizationTime: "32h", utilization: 48 },
];

// ── GeoMap mock locations ──
export const MOCK_SITE_LOCATIONS = [
  { siteId: "s1", siteName: "Site Alpha", lat: 37.7749, lng: -122.4194, chargerCount: 12, country: "US" },
  { siteId: "s2", siteName: "Site Beta", lat: 34.0522, lng: -118.2437, chargerCount: 8, country: "US" },
  { siteId: "s3", siteName: "Site Gamma", lat: 51.5074, lng: -0.1278, chargerCount: 6, country: "GB" },
  { siteId: "s4", siteName: "Site Delta", lat: 48.8566, lng: 2.3522, chargerCount: 10, country: "FR" },
  { siteId: "s5", siteName: "Site Epsilon", lat: 35.6762, lng: 139.6503, chargerCount: 5, country: "JP" },
];
